import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

// ==============================|| HEADER ACTION CONTEXT ||============================== //
//
// Lets a page inject an action (e.g. a back button) into the layout-level page
// header rendered by `components/@extended/Breadcrumbs`. The page registers its
// node via `useHeaderActionSlot(...)`; the header reads it and renders it on the
// right of the breadcrumb/title row. Registration is cleared on unmount so the
// slot is empty for pages that don't set one.

const HeaderActionContext = createContext({ action: null, setAction: () => {} });

export const HeaderActionProvider = ({ children }) => {
  const [action, setAction] = useState(null);
  const value = useMemo(() => ({ action, setAction }), [action]);

  return <HeaderActionContext.Provider value={value}>{children}</HeaderActionContext.Provider>;
};

HeaderActionProvider.propTypes = {
  children: PropTypes.node
};

export const useHeaderAction = () => useContext(HeaderActionContext);

// Register a header action for the lifetime of the calling page/component.
// `deps` control when the node is re-registered (use stable route params).
export const useHeaderActionSlot = (action, deps = []) => {
  const { setAction } = useHeaderAction();

  useEffect(() => {
    setAction(action);
    return () => setAction(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default HeaderActionContext;
